import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useLazyQuery } from "@apollo/client";
import debounce from "lodash/debounce";

import { SEARCH_EVENT_COMPETITORS } from "../graphql/event";
import { SearchRegExp, nonWhitespacePattern } from "../utils/utils";

export const useEventSearch = event => {
    const [isLoading, setIsLoading] = useState();
    const ref = useRef();
    const [searchString, setSearchString] = useState("");
    const onSearch = useCallback(value => setSearchString(value), []);
    const clearSearch = useCallback(() => {
        onSearch("");
        ref.current && ref.current.focus();
    }, [ref.current]);

    const [search, { data, loading }] = useLazyQuery(SEARCH_EVENT_COMPETITORS,
        { fetchPolicy: "cache-and-network", nextFetchPolicy: "cache-first", onCompleted: () => setIsLoading(false) }
    );
    const debouncedSearch = useCallback(debounce(query => {
        search({ variables: { eventId: event.id, query } });
    }, 400), [search]);
    useEffect(() => {
        setIsLoading(true);
        debouncedSearch(searchString);
    }, [searchString]);

    const competitorResults = (data && data.eventCompetitors) || [];
    const eventDivisionResults = useMemo(() => {
        const words = searchString.match(nonWhitespacePattern);
        if (!words) return [];

        return words.reduce((eventDivisions, word) => {
            const searchRegex = SearchRegExp(word);

            return eventDivisions.filter(ed => ed.division.name.match(searchRegex));
        }, event.eventDivisions);
    }, [searchString]);

    return {
        inputRef: ref,
        searchString,
        onSearch,
        clearSearch,
        loading: loading || isLoading,
        searchResults: {
            eventDivisions: eventDivisionResults,
            competitors: competitorResults
        }
    };
};
